export const StyledCheckboxes = () => {
  const checkboxes = document.querySelectorAll('.with_frm_style .frm_checkbox input[type=checkbox]')
  checkboxes.forEach((element, idx, parent) => {
    const spanNode = document.createElement("span");
    element.parentNode.insertBefore(spanNode, element.nextSibling);
  })
}